<template>
  <div>
      <b-container>
      <b-row
        v-if="!loading" 
        class="text-center"
      >
        <b-col></b-col>
        <b-col v-if="isInternetExplorer" cols="10">
          <div role="alert" aria-live="polite" aria-atomic="true" class="alert mt-3 text-center alert-danger">
            <div class="warning">
              This browser is not supported for this page. <span class='d-block'>Please use a different browser, such as Chrome, Safari, Firefox, or Edge.</span>
            </div>
          </div>
        </b-col>
        <b-col v-else cols="10">
          <div v-if="errors.length === 0">
            <div>
              <b-img 
                :src="logoUrl" 
                fluid 
                :alt="`${projectName} logo`" 
                class="logo-image my-3"
              />
            </div>
            <h1 class="h3">{{ projectName }}</h1>
            <b-card
              title="Approve Charter"
              style="background-color: #f2f8f8;"
              class="my-3"
            >
              <div>
                <p>You need to approve the charter before you can participate in project evaluations.</p> 
                <p>Please review and approve the charter below.</p>
                <hr>
                <p>We, the members of the <span class="font-weight-bold">{{ projectName }} project team</span>, commit to achieving the following project goals:</p>
                <ul
                  v-if="hasGoals" 
                  :class="goalsColumnCountClass"
                >
                  <li 
                    v-for="goal in goals"
                    :key="goal.goalId"
                  >
                    {{ goal.name }}
                  </li>
                </ul>
                <p 
                  v-else
                  class="text-center "
                >No goals have been set for this project.</p>
              </div>
            </b-card>
            <b-button 
              variant="primary"
              @click="redirectToApproveCharter"
            >Approve Charter</b-button>
          </div>
          <BaseMessageBlock :messages="uniqueErrors"></BaseMessageBlock>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
    <!-- <img
      src="../assets/logo/svg/dashtech-alt-logo.svg"
      alt="DashTech Logo"
      class="mx-3 py-3"
      width="100px"
    /> -->
  </div>
</template>

<script>
import axios from "axios";
import * as browsers from '@/assets/js/browsers.js'

export default {
  data() {
    return {
      errors: [],
      loading: true,
      isInternetExplorer: false,
      projectId: '',
      userCharterId: '',
      projectName: '',
      goals: [],
      hasApproved: false,
      logoUrl: '',
      redirectUrl: '',
    };
  },
  mounted() {
    this.isInternetExplorer = browsers.isInternetExplorer();
    if (this.isInternetExplorer) {
      this.loading = false;
      return;
    }

    this.userCharterId = this.$route.query.userCharterId;
    this.projectId = this.$route.query.projectId;
    this.redirectUrl = this.$route.query.redirectUrl ? this.$route.query.redirectUrl : '';
    if (!this.projectId || !this.userCharterId) {
      this.errors.push({ message: "No project or charter specified. Please follow the link in the email you received to approve the charter." });
      this.loading = false;
      return;
    }

    this.loadProjectDetails();
  },
  methods: {
    loadProjectDetails() {
      const url = `${this.$api_url}/projects/${this.projectId}/info`;

      axios
        .get(
          url,
        )
        .then((res) => {
          const project = res.data;
          this.projectName = project.projectName;
          this.logoUrl = project.ownerLogo ? project.ownerLogo :
            project.contractorLogo ? project.contractorLogo :
            '';
          this.goals = project.goals && project.goals.goals ?
            project.goals.goals : 
            [];
        })
        .catch((err) => {
          this.$error({
            msg: "Couldn't load project data",
            obj: err,
          });
          this.errors.push({ message: "Project Doesn't Exist." });
          
        })
        .finally(() => {
          this.loading = false;
        });
    },
    redirectToApproveCharter() {
      this.$router.push({ 
        name: 'CharterApproved',
        query: { 
          projectId: this.projectId,
          userCharterId: this.userCharterId,
          redirectUrl: this.redirectUrl
        },
      });
    },
  },
  computed: {
    uniqueErrors() {
      return Array.from(new Set(this.errors.map(e => e.message))).map(m => ({message: m}));
    },
    goalsColumnCountClass() {
      return this.goals.length >= 4 ? 'column-count-2-sm' : '';
    },
    hasGoals() {
      return this.goals.length > 0;
    },
  }
}
</script>

<style scoped>
.surveyTitle {
  color: #555;
}
.logo-image {
  max-height: 100px;
}
</style>